// src/lib/links.ts
// Classify hrefs that must NOT be handled by the Next.js router. Rendering these
// through next/link triggers an RSC prefetch (`?_rsc=…`) that 404s, because the
// destination is served outside Next — either a fully external URL or a path
// proxied to another system via vercel.json rewrites (e.g. /docs → Mintlify).

/** Paths proxied to external systems in vercel.json (not real Next routes). */
const PROXIED_PATH_RES = [/^\/docs(?:[/?#]|$)/i];

export function isAbsoluteUrl(href: string): boolean {
  return (
    /^https?:\/\//i.test(href) ||
    href.startsWith("//") ||
    href.startsWith("mailto:") ||
    href.startsWith("tel:")
  );
}

export function isProxiedPath(href: string): boolean {
  return PROXIED_PATH_RES.some((re) => re.test(href));
}

/** True when the href should be a plain <a> (no Next router / no RSC prefetch). */
export function isNonRouterHref(href: string): boolean {
  return isAbsoluteUrl(href) || isProxiedPath(href);
}
